//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Ben Layton
 * Original Team: Fore oh Four!
 */
import { VLayout, VFlex, VTextField } from 'vuetify/lib';
import { NsIcon } from '@nuskin/ns-icon';

export default {
  name: 'NsPassword',
  components: {
    VLayout,
    VTextField,
    VFlex,
    NsIcon,
  },
  props: {
    /**
     * Translations as a key:value object
     */
    translations: {
      type: Object,
      default: () => {
        return {
          newPassword: 'New Password',
          passwordRequired: 'Password is required',
          excludesWhitespaceChars: 'Password must not include spaces',
          includes8Chars: 'Use 8 or more characters',
          includesUpper: 'Use an upper case letter (e.g. A)',
          includesLower: 'Use a lower case letter (e.g. a)',
          includesNumber: 'Use a number (e.g. 1234)',
          includesSpecialChars: 'Use a symbol (e.g. !@#$)',
          criteriaComplete: 'Your Password is STRONG',
          passwordConditionsMet: "Password doesn't meet minimum requirements",
          hide: 'HIDE',
          show: 'SHOW',
        };
      },
    },
    /**
     * Validate using the password requirement criteria
     */
    criteriaOn: {
      type: Boolean,
      default: true,
    },
    /**
     * Show the password requirement criteria block
     */
    criteriaVisible: {
      type: Boolean,
      default: true,
    },
    /**
     * Number of password requirement criteria to meet
     */
    criteriaCount: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      includes8Chars: false,
      includesUpper: false,
      includesLower: false,
      includesNumber: false,
      includesSpecialChars: false,
      criteriaComplete: false,
      showCriteria: false,
      criteria: {
        excludesWhitespaceChars: {
          regex: /(?=^\S+$)/,
        },
        includes8Chars: {
          regex: /(?=.{8,})/,
        },
        includesUpper: {
          regex: /(?=.*[A-Z])/,
        },
        includesLower: {
          regex: /(?=.*[a-z])/,
        },
        includesNumber: {
          regex: /(?=.*[0-9])/,
        },
        includesSpecialChars: {
          regex: /(?=.*[@#$%^&*()_+?~!])/,
        },
      },
      password: '',
      showPassword: false,
    };
  },
  computed: {
    criteriaBlock() {
      return this.criteriaOn && this.criteriaVisible && this.showCriteria;
    },
    passwordRules() {
      // Grab everything up front to help Vue know our deps
      const { txc, criteria, showCriteria, criteriaOn } = this;
      if (!showCriteria && criteriaOn) {
        return [() => this.passwordValid() || txc.passwordConditionsMet];
      }
      return [
        (v) => !!v || txc.passwordRequired,
        // v => !this.criteriaComplete || txc.passwordConditionsMet
        (v) =>
          (v && criteria.excludesWhitespaceChars.regex.test(v)) ||
          txc.excludesWhitespaceChars,
        () => this.passwordValid() || txc.passwordConditionsMet,
        (v) => (v && v.length > 7) || txc.includes8Chars,
      ];
    },
    txc() {
      return this.translations;
    },
  },
  watch: {
    password() {
      this.includes8Chars =
        this.password &&
        this.password.match(this.criteria.includes8Chars.regex);
      this.includesUpper =
        this.password && this.password.match(this.criteria.includesUpper.regex);
      this.includesLower =
        this.password && this.password.match(this.criteria.includesLower.regex);
      this.includesNumber =
        this.password &&
        this.password.match(this.criteria.includesNumber.regex);
      this.includesSpecialChars =
        this.password &&
        this.password.match(this.criteria.includesSpecialChars.regex);
    },
  },
  methods: {
    onFocus() {
      this.showCriteria = true;
    },
    onBlur() {
      // TODO: why hide?
      this.showCriteria = false;
    },
    onInput() {
      /**
       * @event input
       * @type {string}
       */
      this.$emit('input', this.password);
      /**
       * @event password
       * @type {boolean}
       */
      this.$emit('valid', this.passwordValid());
    },
    passwordValid() {
      let totalCompleted = 0;
      // includesUpper
      if (
        this.password &&
        this.password.match(this.criteria.includesUpper.regex)
      ) {
        totalCompleted++;
      } else {
        totalCompleted += 0;
      }
      // includesLower
      if (
        this.password &&
        this.password.match(this.criteria.includesLower.regex)
      ) {
        totalCompleted++;
      } else {
        totalCompleted += 0;
      }
      // includesNumber
      if (
        this.password &&
        this.password.match(this.criteria.includesNumber.regex)
      ) {
        totalCompleted++;
      } else {
        totalCompleted += 0;
      }
      // includesSpecialChars
      if (
        this.password &&
        this.password.match(this.criteria.includesSpecialChars.regex)
      ) {
        totalCompleted++;
      } else {
        totalCompleted += 0;
      }
      // criteriaCount or more criteria and includes8Chars
      if (
        totalCompleted >= this.criteriaCount - 1 &&
        this.password.length > 7
      ) {
        this.criteriaComplete = true;
        return true;
      } else {
        this.criteriaComplete = false;
        return false;
      }
    },
  },
};
